<template>
    <div class="container">
        <div class="pages" v-if="!loading && !gerando">
            
            <img
                :src="pagina.src"
                alt=""
                v-for="(pagina, index) in paginas"
                :key="index"
            />
        </div>
        <div class="pages" v-else>
            <p>
                <i class="mdi mdi-spin mdi-loading mdi-48px"></i>
            </p>
        </div>
        <div class="toolbar">
            <div class="zoom">
                <button @click.prevent.stop="scale -= 10">-</button>
                <input
                    type="number"
                    v-model="scale"
                    step="10"
                    min="10"
                    max="300"
                />
                <button @click.prevent.stop="scale += 10">+</button>
            </div>
            <div class="print">
                <a @click="print" href="javascript:void(0)"
                    ><i class="mdi mdi-printer"></i
                ></a>
            </div>
        </div>
    </div>
</template>
<script>
import api from "/plugins/api";
//const pdfjsLib = require("pdfjs-dist/build/pdf");
//require("pdfjs-dist/build/pdf.worker.entry");
//import pdfjsLib from '/plugins/pdf';

export default {
    props: ["documento"],
    data() {
        return {
            loading: false,
            gerando: false,
            errors: [],
            arquivos: [],
            paginas: [],
            scale: 100,
        };
    },
    computed: {
        IdDocsprime() {
            return this.documento.IdDocsprime;
        },
        condominio() {
            return this.$store.getters.condominio;
        },
        codigo_condominio() {
            if (!this.condominio) {
                return null;
            }
            return this.condominio.codigo;
        },
    },
    methods: {
        async print() {
            //let old = this.scale;

            let paginas = this.paginas
            let win = window.open("about:blank", "teste");
            setTimeout(() => {
                paginas.forEach((pagina) => {
                    win.document.writeln(`<img src="${pagina.src}" />`);
                });
                win.document.head.innerHTML = `
                        <style>
                            body {
                                text-align: center;
                            }
                            img {
                                max-width: 100%;
                            }
                        <\/style>
                    `;
                
                win.print();
                win.close();
                //this.scale = old;
            }, 3000);
        },
        async loadArquivos() {
            try {
                if (this.loading) {
                    return;
                }
                if (!this.IdDocsprime) {
                    return;
                }
                if (!this.codigo_condominio) {
                    return;
                }

                this.loading = true;

                let { data: arquivos } = await api.get(
                    `condominios/${this.codigo_condominio}/conta-corrente/${this.IdDocsprime}/lista-arquivos`
                );
                this.arquivos = arquivos;

                await this.updatePaginas();
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
        async updatePaginas(retorna = false, alt_scale = null) {
            try {
                let scale = this.scale;
                if (!retorna) {
                    this.gerando = true;
                } else {
                    scale = alt_scale;
                }
                
                //').then(e => e.default);

                let paginas = [];
                for (let arquivo of this.arquivos) {
                    let pdfData = atob(arquivo.conteudoBase64);
                    const pdfjsLib = await import('../../../plugins/pdf').then(e => e.default)
                    let pdf = await pdfjsLib.getDocument({ data: pdfData })
                        .promise;

                    for (let i = 1; i <= pdf.numPages; i++) {
                        let page = await pdf.getPage(i);

                        let iw = page.getViewport({ scale: 1}).width;
                        let pw = document.querySelector('.pages').offsetWidth * 0.80;
                        let initial_scale = 1;
                        if (iw != 0) {
                            initial_scale = pw/iw;
                        }

                        

                        let viewport = page.getViewport({
                            scale: (scale * initial_scale) / 100,
                        });
                        let canvas = document.createElement("canvas");
                        let ctx = canvas.getContext("2d");
                        canvas.width = viewport.width;
                        canvas.height = viewport.height;

                        
                       

                        let renderContext = {
                            canvasContext: ctx,
                            viewport,
                        };
                        await page.render(renderContext).promise;
                        let src = canvas.toDataURL("image/png");

                        paginas.push({
                            page: i,
                            src,
                        });
                    }
                }
                if (retorna) {
                    return paginas;
                }
                this.paginas = paginas;
            } catch (err) {
                console.error(err);
                if (retorna) {
                    return [];
                }
            }
            this.gerando = false;
        },
    },
    watch: {
        IdDocsprime: {
            immediate: true,
            handler() {
                this.loadArquivos();
            },
        },
        scale(value) {
            if (value < 10) {
                this.scale = 10;
                return;
            }
            if (value > 300) {
                this.scale = 300;
                return;
            }
            this.updatePaginas();
        },
    },
};
</script>
<style lang="less" scoped>
.container {
    display: grid;
    grid-template-areas:
        "toolbar"
        "pages";
    grid-template-rows: 3em 1fr;
    grid-template-columns: 1fr;
    height: 100%;
    .pages {
        grid-area: pages;
        background: #333;
        padding: 1em;
        box-sizing: border-box;
        overflow: auto;

        flex-direction: column;
        text-align: center;
        img {
            max-width: none;
            display: block;
            margin: auto;
            margin-bottom: 1em;
        }
        p {
            color: white;
            text-align: center;
        }
    }
    .toolbar {
        grid-area: toolbar;
        display: flex;
        justify-content: center;

        .zoom {
            display: flex;
            align-items: center;
            input {
                width: auto;
                margin: 0;
                height: auto;
                padding: 0.25em;
            }
            button {
                display: block;
                background: transparent;
                border: 0;
                font-size: 2em;
                width: 48px;
            }
        }
        .print {
            display: flex;
            align-items: center;
            a {
                color: white;
                font-size: 18px;
                border-left: 1px solid rgba(0, 0, 0, 0.25);
                i {
                    margin: 1em;
                }
            }
        }
    }
}
</style>
